import { render, staticRenderFns } from "./LevyCalculationPanelSpecialTuitionProtection.vue?vue&type=template&id=e6f2a840&"
import script from "./LevyCalculationPanelSpecialTuitionProtection.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelSpecialTuitionProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports